var configs = require("../../public/config.json");

import getAppStrings from "./appStrings";

const getPromoCodeInfo = (
  gainStage,
  gainType,
  gainAmount,
  afterGainAmount,
  beforeGainAmount,
  points
) => {
  if (gainStage === "AFTER") {
    if (gainType === "POINTS") {
      const info = getAppStrings(2610);
      const infoMessage =
        (info && info.message) ||
        "Promotion added successfully! You will receive [:par1] eCoins after completing your order.";
      const message = infoMessage.replace("[:par1]", gainAmount);
      const title = (info && info.title) || "Hooray!";
      return {
        title,
        message
      };
    } else {
      const info = getAppStrings(2609);
      const message = (info && info.message) || "Promotion added successfully!";
      const title = (info && info.title) || "Hooray!";
      return {
        message,
        title
      };
    }
  } else if (gainStage === "BEFORE_AFTER") {
    if (gainType === "POINTS") {
      const info = getAppStrings(2611);
      const totalPoints = parseInt(points) + parseInt(beforeGainAmount);
      const infoMessage =
        (info && info.message) ||
        "You have [:par1] Local E eCoins. Order now and get another [:par2] eCoins to spend!";
      const message = infoMessage
        .replace("[:par1]", totalPoints)
        .replace("[:par2]", afterGainAmount);
      const titleMessage = (info && info.title) || "[:par1] eCoins Added!";
      const title = titleMessage.replace("[:par1]", beforeGainAmount);
      return {
        title,
        message
      };
    }
  } else if (gainStage === "BEFORE") {
    if (gainType === "POINTS") {
      const info = getAppStrings(2608);
      const infoMessage =
        (info && info.message) ||
        "You have [:par1] Local E eCoins to spend.\n(£1.00 = [:par2] eCoins)";
      const message = infoMessage
        .replace("[:par1]", gainAmount)
        .replace("[:par2]", configs.ptsToGbp);
      const titleMessage = (info && info.title) || "[:par1] eCoins Added!";
      const title = titleMessage.replace("[:par1]", gainAmount);
      return {
        title,
        message
      };
    }
  }
  return {
    title: "",
    message: ""
  };
};

export default getPromoCodeInfo;
